import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Cell } from '../../../DataStructures/TableModel/Cell';
import { Moment } from 'moment';
import { Area } from '../../../DataStructures/Area/Area';
import { UserService } from '../../../services/user-service/user.service';
import { QuickDialog } from '../../../utilities/Dialog/QuickDialog';
import { WeekPickerTableComponent } from '../week-picker-table/week-picker-table.component';
import * as moment from 'moment';
import { DateConstants } from '../../../utilities/WeekSchedule/DateConstants';
import { MainService } from '../../../services/optimizer-service/optimizer.service';
import { MapquestService } from '../../../services/map-quest/mapquest.service';
declare var google: any;

@Component({
  selector: 'app-cell-editor-dialog',
  templateUrl: './cell-editor-dialog.component.html',
  styleUrls: ['./cell-editor-dialog.component.css']
})

export class CellEditorDialogComponent<Row,Col,Data> implements OnInit {

  cell:Cell<any,any,any>
  checkedAreas:Array<Area> = [];
  checkedUsers:Array<any> = [];
  addMode:boolean = false;
  users:Array<any>;
  filterList:Array<any>;
  areaFilterList:Array<Area>;
  areas:Array<Area>;
  params:CellEditorData<Row,Col,Data>

  constructor(private userService:UserService,private dialog: MatDialog,public dialogRef: MatDialogRef<CellEditorDialogComponent<Row,Col,Data>>,
    @Inject(MAT_DIALOG_DATA) public data: CellEditorData<Row,Col,Data>,private optimizer:MainService,private mapquest:MapquestService) {
      this.cell = data.cell;
      this.areas = this.cell.getData();
      this.areaFilterList = this.areas;
      this.params = data;
    }

  ngOnInit() {
  }

  removeArea(area){


  }

  viewSet(){
    this.params.table.controls.viewAreas(this.params.cell.getData());
  }

  formatCol(colHead: Moment): string {
    return colHead.format("dddd MMMM D");
  }

  checked(value,area){

    if(value){
      this.checkedAreas.push(area);
    }else{
      this.checkedAreas.splice(this.checkedAreas.indexOf(area),1);
    }
    console.log(this.checkedAreas);
  }

  toggleCheckboxes(state:boolean){
    let checkboxes :any = document.getElementsByClassName('mCheckbox');
    for(var i=0, n=checkboxes.length;i<n;i++) {
      checkboxes[i].checked = state;
    }
  }

  checkAll(){
    this.areaFilterList.forEach(a=>{
      this.checkedAreas.push(a);
    });
    this.toggleCheckboxes(true);
  }

  uncheckAll(){
    this.checkedAreas = [];
    this.toggleCheckboxes(false);
  }
  



  removeAllChecked(){

    if(this.checkedAreas.length == 0){
      new QuickDialog(this.dialog).InfoDialog("You did not select any users","No Users Selected","OK");
      return;
    }

    new QuickDialog(this.dialog).
    DecisionDialog({ message:`Are you sure you want to remove ${this.checkedAreas.length} users?`, options:[
      {
        icon: 'fa-thumbs-up',
        code:'yes',
        message:"Yes"
      },
      {
        icon: 'fa-ban',
        code:'no',
        message:'Cancel'
      }
    ]}).then((choice) =>{
      if(choice == 'yes'){
        var date : Moment = this.cell.getColoumn().getColoumnHead().getDayForHour(this.cell.getRow().getRowHead())
        var d = new QuickDialog(this.dialog).LoadingDialog("Removing users....");
        var body = {
          areas:this.checkedAreas,
          day:date.format("dddd")
        }
    
        this.userService.removeUserFromRun(body).then((res:any) => {
          d.close();
          if(res.status){
            new QuickDialog(this.dialog).InfoDialog("Users Removed","Success","OK");
            this.data.table.reload();
          }else{
            new QuickDialog(this.dialog).InfoDialog(res.message,"Could Not Remove Users","OK");
          }
    
        }).catch(e =>{
          d.close();
          new QuickDialog(this.dialog).InfoDialog(e,"Could Not Remove Users","OK");
        })
        this.dialogRef.close();
      }
    });
  }

  moveAllChecked(){
    if(this.checkedAreas.length == 0){
      new QuickDialog(this.dialog).InfoDialog("You did not select any users","No Users Selected","OK");
      return;
    }
    this.data.table.enterEditorModeForMove({
      areas:this.checkedAreas,
      cell:this.cell
    }); 
    this.dialogRef.close();
  }

  enterAddMode(){
    this.addMode = true;
    var d = new QuickDialog(this.dialog).LoadingDialog("Loading Users...");
    this.userService.getUserByCompany(this.data.companyid).then((res:any) =>{
      
      d.close();

      if(res.status){

        this.users = res.data;
        var areas : Array<Area> = this.cell.getData();
        this.users = this.users.filter(u => areas.find(a => a.userid == u.userid) == null);
        this.filterList = this.users;
      }else{
        new QuickDialog(this.dialog).InfoDialog(res.message,"","Ok");
      }
    }).catch(e =>{
      d.close();
      new QuickDialog(this.dialog).InfoDialog(e,"","Ok");
    })
  }

  addUsers(){
    var pickupdata = [];
    var newDate: Moment =this.data.cell.getColoumn().getColoumnHead().getDayForHour(this.data.cell.getRow().getRowHead());
    var time: string = moment(newDate.format(DateConstants.standardDateFormat + " ") + this.data.cell.getRow().getRowHead()).format(DateConstants.standard24hHrDateTimeFormat);

    this.checkedUsers.forEach(u =>{
      var data = {
        "userid":u.employeeid,
        "weekid":this.data.table.week.weekid
      };
      var day = newDate.format("dddd");
      data[day] = time;
      pickupdata.push(data);
    });
    var d = new QuickDialog(this.dialog).LoadingDialog("Adding Users...");
    this.userService.addUserPickup(pickupdata).then((res:any) =>{
      d.close();
      if(res.status){
        this.data.table.reload();
        new QuickDialog(this.dialog).InfoDialog("Users added","Success","OK");
      }else{
        new QuickDialog(this.dialog).InfoDialog(res.message,"Error","OK");
      }
    }).catch(e =>{
      d.close();
      new QuickDialog(this.dialog).InfoDialog(e,"Error","OK");
    })
    console.log(this.checkedUsers);
  }

  filterUsers(substring : string){
    substring = substring.trim().toLowerCase();

    if(this.addMode){
      if(substring.trim() == ""){
        this.filterList = this.users;
      }else{
        this.filterList = this.users.filter(x => (x.firstname.toLowerCase() +" "+ x.lastname.toLowerCase()).includes(substring));
      }
    }else{
      if(substring.trim() == ""){
        this.areaFilterList = this.areas;
      }else{
        this.areaFilterList = this.areas.filter(x => x.destinations[0].person.toLowerCase().includes(substring));
      }
    }

  }

  shouldCheckUser(cbox,user){
    var u = this.checkedUsers.find(x => x.userid == user.userid);
    if(u){
      return true;
    }else{
      return false;
    }
  }

  showSelectedUsers(){
    this.filterList = this.checkedUsers;
  }

  userChecked(value,user){
    console.log(value);
    console.log(user);
    if(value){
      this.checkedUsers.push(user);
    }else{
      this.checkedUsers.splice(this.checkedUsers.indexOf(user),1);
    }
    console.log(this.checkedUsers);
  }

  matrix(){
    console.time("request");
    this.optimizer.calculatecDistanceMatrix(this.cell.getData(),this.data.table.controls.optimizerComponent.getOrigin())
    .then(res =>{
      console.timeEnd("request");
      console.log(res);
    }).catch(e => alert(e));
  }

  computeHeading(){
    var areas: Array<Area> = this.cell.getData();
    var source = areas[0].getLatLng();


    for(var i = 1; i < areas.length;i++){
      var dest = areas[i].getLatLng();
      var heading = google.maps.geometry.spherical.computeHeading(
        new google.maps.LatLng(source.lat,source.lng),
        new google.maps.LatLng(dest.lat,dest.lng) 
      );
    }

  }

  async mapQuestMatrix(){
    var areas : Array<Area> = this.cell.getData()
    this.mapquest.clusterPoints(areas).then(res =>{
      this.dialogRef.close({
        areas:areas,
        result:res
      });
    }).catch(e =>{
      console.log(e);
    })
  }
}



export interface CellEditorData<Row,Col,Data>{

  cell:Cell<any,any,any>
  table:WeekPickerTableComponent,
  companyid:number,
  locationid:number
}
